import { type OfferV11 } from '@redteclab/api/clients/bully'

import { offerAccessorGetVolumePricing } from './offerAccessorGetVolumePricing'

export const offerAccessorOfferHasVolumePricing = (
  currentOffer: OfferV11 | undefined,
): boolean | undefined => {
  const volumeBasedPrices = offerAccessorGetVolumePricing(currentOffer)
  if (!volumeBasedPrices) {
    return false
  }

  return volumeBasedPrices.length > 1
}
